export default class PrincipalService{
    constructor(axios, snackbar) {
        this.axios = axios;
        this.snackbar=snackbar;
    }

    principal() {
        return this.axios.post("/api/utilisateur/authenticate")
        .catch(this.snackbar.catch())
        .then(response=>response.data.utilisateur);
    }

    dashboardAssociations() {
        return this.axios.post("/api/utilisateur/dashboard-association")
        .catch(this.snackbar.catch())
        .then(response=>response.data);
    }

    dashboardRequetes() {
        return this.axios.post("/api/utilisateur/dashboard-requete")
        .catch(this.snackbar.catch())
        .then(response=>response.data);
    }

    modifier(body) {
        return this.axios.put("/oauth2/utilisateur/mesinfos", body)
            .catch(this.snackbar.catch())
            .then(response => response.data);
    }

    modifierMotPasse(ancien, motPasse) {
        return this.axios.post("/oauth2/utilisateur/changeMotPasse", {ancien, motPasse})
            .catch(this.snackbar.catch())
            .then(response => response.data);
    }

    changementAdresseMail(email) {
        return this.axios.post("/oauth2/utilisateur/mail", {email})
            .catch(this.snackbar.catch())
            .then(response => response.data);
    }
}
